import {
    START_LOADING,
    END_LOADING,
    FETCH_UNITS,
    FETCH_UNIT,
    ADD_UNIT,
    UPDATE_UNIT,
    DELETE_UNIT,
} from '../actions/constants';

const units = (state = { isLoading: false, units: [], unit: null }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_UNITS:
      return {
        ...state,
        units: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_UNIT:
      return { ...state, unit: action.payload.data };
    case ADD_UNIT:
      return { ...state, units: [...state.units, action.payload] };
    case UPDATE_UNIT:
      return {
        ...state,
        units: state.units.map((unit) =>
          unit._id === action.payload._id ? action.payload : unit
        ),
      };
    case DELETE_UNIT:
      return {
        ...state,
        units: state.units.filter((unit) => unit._id !== action.payload),
      };
    default:
      return state;
  }
};

export default units;